import Vue from "vue";
import Router from "vue-router";

import pageView from "@/pages/pageView";
import Home from "@/pages/home";
import Things from "@/pages/things";
import myOrder from "@/pages/myOrder";

Router.prototype.goBack = function() {
  this.isBack = true;
  window.history.go(-1);
};

Vue.use(Router);

const routers = new Router({
  routes: [
    {
      path: "",
      name: "",
      component: pageView,
      children: [
        {
          path: "/",
          name: "home",
          component: Home
        },
        {
          path: "/things/:id",
          name: "things",
          meta: { index: 1 },
          component: Things
        },
        {
          path: "myOrder",
          name: "myOrder",
          meta: { index: 1 },
          component: myOrder
        }
      ]
    }
  ]
});

routers.beforeEach(function(to, from, next) {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
  next();
});

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js